import { render, staticRenderFns } from "./ticket-admin-table.vue?vue&type=template&id=3b34049a"
import script from "./ticket-admin-table.vue?vue&type=script&lang=js"
export * from "./ticket-admin-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b34049a')) {
      api.createRecord('3b34049a', component.options)
    } else {
      api.reload('3b34049a', component.options)
    }
    module.hot.accept("./ticket-admin-table.vue?vue&type=template&id=3b34049a", function () {
      api.rerender('3b34049a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/ticket-admin-table.vue"
export default component.exports